import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';


@Component({
  selector: 'app-alma-accounting-entries-file-exporter-configuration',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './alma-ae-file-exporter-configuration.component.html',
  styleUrls: ['./alma-ae-file-exporter-configuration.component.scss']
})
export class AlmaAccountingEntriesFileExporterConfigurationComponent {
  formGroup: FormGroup;

  constructor(
    readonly fb: FormBuilder

  ) {
    this.formGroup = fb.group({});
  }
}